export function usersOnPermissionType(options) {
    const { accessTypeUsers, accessType, owners } = options;
    const users = accessTypeUsers[accessType];
    const userIds = users.map((user) => user.id);
    if (accessType === 'access') {
        return { users: [...owners, ...users], userIds };
    }
    return { users, userIds };
}
